"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "olgiate-olona": {
    "576e6202": [{
      "hkey": "a8d39883",
      "slug": "olgiate-olona",
      "name": "Olgiate Olona",
      "primary": true,
      "skipSearch": false
    }],
    "buon-gesu": [{
      "hkey": "a8d39883",
      "slug": "olgiate-olona",
      "name": "Olgiate Olona",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "955f97b8": [{
      "hkey": "a8d39883",
      "slug": "olgiate-olona",
      "name": "Olgiate Olona",
      "primary": true,
      "skipSearch": false
    }],
    "c-na-belvisi": [{
      "hkey": "a8d39883",
      "slug": "olgiate-olona",
      "name": "Olgiate Olona",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "30e0ded9": [{
      "hkey": "a8d39883",
      "slug": "olgiate-olona",
      "name": "Olgiate Olona",
      "primary": true,
      "skipSearch": false
    }],
    "c-na-cerini": [{
      "hkey": "a8d39883",
      "slug": "olgiate-olona",
      "name": "Olgiate Olona",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "b0bb361d": [{
      "hkey": "a8d39883",
      "slug": "olgiate-olona",
      "name": "Olgiate Olona",
      "primary": true,
      "skipSearch": false
    }],
    "c-na-solbiati": [{
      "hkey": "a8d39883",
      "slug": "olgiate-olona",
      "name": "Olgiate Olona",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "2e0c1707": [{
      "hkey": "a8d39883",
      "slug": "olgiate-olona",
      "name": "Olgiate Olona",
      "primary": true,
      "skipSearch": false
    }],
    "gerbone": [{
      "hkey": "a8d39883",
      "slug": "olgiate-olona",
      "name": "Olgiate Olona",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "ef20a13d": [{
      "hkey": "a8d39883",
      "slug": "olgiate-olona",
      "name": "Olgiate Olona",
      "primary": true,
      "skipSearch": false
    }],
    "il-bersaglio": [{
      "hkey": "a8d39883",
      "slug": "olgiate-olona",
      "name": "Olgiate Olona",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "3c644153": [{
      "hkey": "a8d39883",
      "slug": "olgiate-olona",
      "name": "Olgiate Olona",
      "primary": true,
      "skipSearch": false
    }],
    "isola-dei-cacciatori": [{
      "hkey": "a8d39883",
      "slug": "olgiate-olona",
      "name": "Olgiate Olona",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;